import type { UploadFile } from 'antd';

/**
 * Extract file IDs from upload file list
 * @param fileList - Array of UploadFile from Ant Design Upload component
 * @returns Array of file IDs
 */
export const getFileIds = (fileList?: UploadFile[]): number[] => {
  if (!fileList || fileList.length === 0) {
    return [];
  }

  return fileList
    .filter((file) => file.status === 'done')
    .map((file) => {
      // Handle different response structures
      const id = file.response?.result?.id ?? file.response?.id ?? null;
      return id;
    })
    .filter((id): id is number => id !== null);
};

/**
 * Convert file IDs array to UploadFile array (for loading existing data)
 * @param fileIds - Array of file IDs
 * @param files - Optional array of file objects with details
 * @returns Array of UploadFile
 */
export const fileIdsToUploadFiles = (
  fileIds?: number[],
  files?: Array<{ id: number; url: string; name?: string }>
): UploadFile[] => {
  if (!fileIds || fileIds.length === 0) {
    return [];
  }

  return fileIds.map((id) => {
    const fileInfo = files?.find((f) => f.id === id);
    return {
      uid: `${id}`,
      name: fileInfo?.name || `file-${id}`,
      status: 'done',
      url: fileInfo?.url,
      response: {
        result: {
          id,
        },
      },
    } as UploadFile;
  });
};
